import {gql} from 'apollo-angular';
import {ImageFragment} from "./fragments/Image";

export const GET_ROOKIE_PROVIDERS = gql`
  query RookieProviders($districtId: Int!, $schoolId: Int!) {
    rookieProviders(districtId: $districtId, schoolId: $schoolId) {
      id
      uuid
      name
      companySize {
        id
        name
      }
      founded
      locations {
        id
        name
        address {
          id
          street
          number
          addressCity {
            id
            name
          }
        }
      }
      companyBenefits {
        id
        name
      }
      mediaGallery {
        galleryItems {
          image {
            ...imageFields
          }
        }
      }
      headerPicture {
        id
        name
        image {
          info {
            caption
            copyright
          }
          medium {
            url
            width
          }
        }
      }
      companyProfilePicture {
        id
        name
        image {
          ...imageFields
        }
      }
    }
  }
  ${ImageFragment}
`;
